import styled from 'styled-components';

export const ModalBackdrop = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 16px;
  box-sizing: border-box;
`;

export const ModalCard = styled.div`
  background: var(--white);
  border-radius: 8px;
  max-width: 440px;
  width: 100%;
  padding: 24px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
  box-sizing: border-box;
`;

export const ModalTitle = styled.h2`
  font-size: 22px;
  font-weight: 400;
  margin-bottom: 12px;
  color: var(--ins-blue);
`;

export const ModalText = styled.p`
  font-size: 15px;
  margin-bottom: 8px;
  color: var(--gray-900);
  line-height: 1.4;
`;

export const ModalInput = styled.input`
  width: 100%;
  height: 40px;
  border: 1px solid var(--gray-400);
  border-radius: 4px;
  padding: 0 12px;
  margin-bottom: 10px;
  box-sizing: border-box;
  font-size: 16px;
`;

export const ModalError = styled.p`
  font-size: 14px;
  color: var(--feedback-negative);
  margin: 6px 0 8px;
`;

export const ModalActions = styled.div`
  display: flex;
  gap: 10px;
  margin-top: 10px;
  flex-wrap: wrap;
`;

export const ModalButton = styled.button<{ $primary?: boolean }>`
  flex: 1;
  min-width: 120px;
  height: 42px;
  border-radius: 8px;
  border: none;
  cursor: pointer;
  font-size: 15px;
  background: ${(p) => (p.$primary ? 'var(--ins-blue)' : 'var(--gray-300)')};
  color: ${(p) => (p.$primary ? 'var(--white)' : 'var(--black)')};

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;
